var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartyRoom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 80,
    viewBox: "0 0 90.53 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "party_room",
    "data-name": "party room",
    transform: "translate(-11.519 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_195",
    "data-name": "Grupo 195",
    transform: "translate(11.519 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1311",
    "data-name": "Caminho 1311",
    d: "M101.875,87.794a2.918,2.918,0,0,0-3.736-1.753L92.168,88.2l-9.792-27.11a17.366,17.366,0,0,0,7.759-20.973L76.342,1.927A2.918,2.918,0,0,0,72.607.174L56.785,5.889,40.962.174a2.918,2.918,0,0,0-3.736,1.753L23.434,40.114a17.366,17.366,0,0,0,7.759,20.973L21.4,88.2,15.43,86.04a2.918,2.918,0,0,0-1.983,5.489l17.432,6.3a2.918,2.918,0,0,0,1.983-5.489L26.89,90.18l9.79-27.1A17.346,17.346,0,0,0,56.052,51.9l.732-2.026.732,2.026a17.289,17.289,0,0,0,19.372,11.18l9.79,27.1-5.971,2.157a2.918,2.918,0,1,0,1.983,5.489l17.432-6.3A2.917,2.917,0,0,0,101.875,87.794ZM69.742,11.478a2.918,2.918,0,0,0-1.65-1.5l-2.717-.981,6.47-2.337,6.38,17.662L64.182,29.389l5.663-15.68A2.918,2.918,0,0,0,69.742,11.478ZM50.563,49.913A11.5,11.5,0,1,1,28.923,42.1l4.439-12.29L55,37.623Zm6.422-17.779L35.344,24.317l6.38-17.662,21.641,7.816ZM77.734,56.825a11.5,11.5,0,0,1-14.728-6.912L59.887,41.28,61.6,36.526l18.6-6.719L84.646,42.1A11.518,11.518,0,0,1,77.734,56.825Z",
    transform: "translate(-11.519 0)",
    fill: "#cb8f55"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartyRoom);
export default __webpack_public_path__ + "static/media/party-room.9e4f166485309e86b6f4d0e71fa1587f.svg";
export { ForwardRef as ReactComponent };